export const getSettingByUrl = (storefrontPages, path) => {
  const currentLink = path.toLowerCase();
  const storefrontPage = storefrontPages.find(
    (storefrontPage) => `/${storefrontPage.navigationLink}` === currentLink
  );
  return storefrontPage ? storefrontPage.pageSetting : {};
};
